module.exports = __webpack_public_path__ + "img/frame (34).d00fcf95.jpg";